var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSurveyNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 4.5,
    fill: "white",
    stroke: "#E0E0E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3634 18.7344C23.3634 18.346 23.0512 18.0312 22.666 18.0312H15.483C15.0979 18.0312 14.7856 18.346 14.7856 18.7344C14.7856 19.1227 15.0979 19.4375 15.483 19.4375H22.666C23.0512 19.4375 23.3634 19.1227 23.3634 18.7344Z",
    fill: "#007AFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.483 20.8438C15.0979 20.8438 14.7856 21.1585 14.7856 21.5469C14.7856 21.9352 15.0979 22.25 15.483 22.25H19.8455C20.2307 22.25 20.5429 21.9352 20.5429 21.5469C20.5429 21.1585 20.2307 20.8438 19.8455 20.8438H15.483Z",
    fill: "#007AFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1219 27.5938H14.7895C14.0205 27.5938 13.3948 26.9629 13.3948 26.1875V13.8125C13.3948 13.0371 14.0205 12.4062 14.7895 12.4062H23.3634C24.1325 12.4062 24.7582 13.0371 24.7582 13.8125V18.1367C24.7582 18.5251 25.0704 18.8398 25.4556 18.8398C25.8407 18.8398 26.153 18.5251 26.153 18.1367V13.8125C26.153 12.2617 24.9016 11 23.3634 11H14.7895C13.2514 11 12 12.2617 12 13.8125V26.1875C12 27.7383 13.2514 29 14.7895 29H17.1219C17.507 29 17.8193 28.6852 17.8193 28.2969C17.8193 27.9085 17.507 27.5938 17.1219 27.5938Z",
    fill: "#007AFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3882 21.1802C26.5724 20.3578 25.2452 20.3578 24.43 21.1797L20.6013 25.0314C20.52 25.1132 20.46 25.214 20.4266 25.3248L19.5928 28.0925C19.5188 28.3378 19.5832 28.6043 19.7609 28.7878C19.8939 28.9253 20.0747 29 20.2601 29C20.3221 29 20.3847 28.9916 20.4462 28.9744L23.261 28.1883C23.3768 28.1559 23.4824 28.094 23.5675 28.0083L27.3882 24.1634C28.2039 23.3409 28.2039 22.0028 27.3882 21.1802ZM22.712 26.8824L21.2959 27.278L21.7103 25.9023L24.2937 23.3034L25.2801 24.298L22.712 26.8824ZM26.4025 23.1686L26.2673 23.3046L25.2811 22.3102L25.4157 22.1747C25.6876 21.9005 26.1301 21.9005 26.402 22.1747C26.6739 22.4488 26.6739 22.8949 26.4025 23.1686Z",
    fill: "#007AFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.666 15.2188H15.483C15.0979 15.2188 14.7856 15.5335 14.7856 15.9219C14.7856 16.3102 15.0979 16.625 15.483 16.625H22.666C23.0512 16.625 23.3634 16.3102 23.3634 15.9219C23.3634 15.5335 23.0512 15.2188 22.666 15.2188Z",
    fill: "#007AFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyNote);
export default __webpack_public_path__ + "static/media/survey-note.ec3acf71ba5c10f3452e83189cf83098.svg";
export { ForwardRef as ReactComponent };